const Message = require('./Message').default
/**
 * @typedef {import('./Game').Game} Game
 */
/**
 * 表示一個場景
 *
 * 該場景可以有數個Message
 */
export class Scene{
  /**
   * @callback EventCallback
   * @param {Game} game
   * @param {*} data
   */
  /**
   * TODO 補上缺少的屬性
   * @typedef {Scene|{
   *  onInput: EventCallback,,
   *  onAfterInput: EventCallback
   *  onEvent: EventCallback,
   *  onAfterEvent: EventCallback
   * }} SceneOptions
   */
  /**
   * @param {SceneOptions} opts
   */
  constructor(opts = {}){
    /** @type {string} */
    this.id = opts.id
    /** @type {string} */
    this.type = opts.type || 'default'
    /** @type {string} */
    this.backgroundColor = opts.backgroundColor || 'black'
    /** @type {Object.<string, Message>} */
    this.messagesMap = {}
    /** @type {Message[]} */
    this.messages = opts.messages || []
    this.messages = this.messages.map((msg)=>{
      let message = new Message(msg)
      if(message.id){
        this.messagesMap[message.id] = message
      }
      return message
    })
    /**
     * 暫時儲存資料用
     * 不序列化該欄位
     * @property {Object}
     * @name Scene#data
     */
    Object.defineProperty(this, 'data', {
      enumerable: false,
      value: opts.data || {}
    })
    this._onInput = opts.onInput || doNothing
    this._onAfterInput = opts.onAfterInput || doNothing
    this._onEvent = opts.onEvent || doNothing
    this._onAfterEvent = opts.onAfterEvent || doNothing
  }
  /**
   *
   * @param {Game} game
   * @param {*} data
   */
  async onInput(game, data){
    await this._onInput(game, data)
    if(game.currentMessage && !data.stop){
      await game.currentMessage.onInput(game, data)
    }
    if(!data.stop){
      await this._onAfterInput(game, data)
    }
  }
  /**
   *
   * @param {Game} game
   * @param {*} data
   */
  async onEvent(game, data){
    await this._onEvent(game, data)
    if(game.currentMessage && !data.stop){
      await game.currentMessage.onEvent(game, data)
    }
    if(!data.stop){
      await this._onAfterEvent(game, data)
    }
  }
  addMessage(message, i = null){
    if(Number.isInteger(i)){
      // insert
      this.messages.splice(i, 0, message)
      this.messagesMap[message.id] = message
    }else{
      // push
      this.messages.push(message)
      this.messagesMap[message.id] = message
    }
  }
  removeMessage(id){
    let i = this.messages.findIndex((msg)=>msg.id === id)
    if(i !== -1){
      this.messages.splice(i, 1)
      delete this.messagesMap[id]
    }
  }
  static generate(opts = {}){
    let scene = new Scene({
      id: opts.id || 'START'
    })
    scene.addMessage(new Message({
      id: 'START'
    }))
    return scene
  }
  validate(){
    // TODO
  }
  toJSON(){
    let obj = { ...this }
    delete obj.messagesMap
    return obj
  }
}
function doNothing(){}

export default Scene
